<template>
  <v-container class="px-0">
    <v-row no-gutters>
      <v-col>
        <v-row no-gutters>
          <v-col class="d-flex mb-1">
            <v-btn
              class="mx-2"
              color="secondary"
              small
              @click="openAddOrderDialog"
              ><v-icon>{{ mdiPlus }}</v-icon
              >{{ $t("label.add") }}</v-btn
            >
            <v-dialog
              v-model="addOrderDialog"
              width="500"
              persistent
              :fullscreen="isFlutter"
            >
              <v-card>
                <v-card-title
                  class="headline font-weight-bold dialog-title py-2"
                >
                  {{ $t("label.add_order") }}
                </v-card-title>
                <v-divider class="py-1"></v-divider>
                <v-text-field
                  v-model="order.CourierNo"
                  :label="$t('label.courier_no')"
                  outlined
                  class="px-2 py-0"
                  :error-messages="CourierNoMsg"
                  v-uppercase
                ></v-text-field>
                <SelectWarehouse
                  class="px-2"
                  v-model="Warehouse"
                  :error-messages="WarehouseMsg"
                  clearable
                  item-text="Warehouse.OriginWhName"
                  item-value="Warehouse.OriginWhCode"
                  :label="$t('label.warehouse')"
                  hide-no-data
                ></SelectWarehouse>
                <div>
                  <v-chip
                    small
                    class="mx-2 my-2"
                    @click="selectProductOption(option)"
                    :key="option"
                    v-for="option in productOptions"
                  >
                    {{ option }}
                  </v-chip>
                </div>
                <v-text-field
                  v-model="order.ProductName"
                  :label="$t('label.product_name')"
                  outlined
                  class="px-2 my-1"
                  :error-messages="ProductNameMsg"
                  v-uppercase
                ></v-text-field>
                <v-text-field
                  v-mask="'#########'"
                  @focus="$event.target.select()"
                  v-model="order.Pkg"
                  :label="$t('label.package')"
                  outlined
                  class="px-2 py-1"
                  :error-messages="PkgMsg"
                ></v-text-field>
                <v-text-field
                  v-model="order.MemberRemark"
                  :label="$t('label.remark')"
                  outlined
                  class="px-2 py-1"
                ></v-text-field>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="secondary" small @click="addOrder" class="mr-2">
                    <v-icon>{{ mdiPlus }}</v-icon
                    >{{ $t("label.add") }}
                  </v-btn>

                  <v-btn
                    color="secondary"
                    small
                    @click="addOrderDialog = false"
                  >
                    <v-icon>{{ mdiClose }}</v-icon
                    >{{ $t("label.cancel") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-btn class="mx-2" color="secondary" small @click="refreshOrder"
              ><v-icon>{{ mdiRefresh }}</v-icon
              >{{ $t("label.refresh") }}</v-btn
            >
            <!-- <v-btn class="mx-2" color="secondary" small @click="testPaymeQrCode"
              ><v-icon>{{ mdiRefresh }}</v-icon
              >Test Payme QR</v-btn
            > -->
            <alipay-dialog
              :url="alipayUrl"
              :header="alipayHeader"
              :paymentId="alipayPaymentId"
              v-model="showAlipayQrForm"
              @onAlipay="afterAlipayFinished"
              width="500"
            >
            </alipay-dialog>

            <payme-dialog
              :url="paymeDialogConfig.url"
              :logoUrl="paymeDialogConfig.logoUrl"
              :header="paymeDialogConfig.header"
              :paymentId="paymeDialogConfig.paymentId"
              v-model="showPaymeQrForm"
              @onPayme="afterPaymeFinished"
              width="500"
              ref="paymeDialog"
            >
            </payme-dialog>

            <polling-dialog
              :paymentId="pollingDialogConfig.paymentId"
              :interval="pollingDialogConfig.interval"
              v-model="showPollingDialog"
              @onPayment="afterPaymentPollingFinished"
              ref="pollingDialog"
            >
            </polling-dialog>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-tabs
          background-color="#009964"
          center-active
          dark
          v-model="tab"
          show-arrows
        >
          <v-tab key="orderTab1" @click="searchOrder('ORDER_PENDING')">{{
            $t("label.pending")
          }}</v-tab>
          <v-tab key="orderTab2" @click="searchOrder('ORIGIN_IN')">{{
            $t("label.gate_in")
          }}</v-tab>
          <v-tab key="bundleTab1" @click="searchBundle('PROCESSING')">{{
            $t("label.ready_delivery_cargo")
          }}</v-tab>
          <v-tab key="bundleTab3" @click="searchBundle('DELIVERED')">{{
            $t("label.delivered")
          }}</v-tab>
          <v-tab key="claimCargoTab4">{{ $t("label.claim_cargo") }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" touchless>
          <v-tab-item key="orderTab1">
            <v-card flat>
              <v-data-table
                :headers="pendingHeaders"
                :items="pendingOrders"
                :items-per-page="10"
                class="elevation-1"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn
                    color="secondary"
                    small
                    class="ma-2"
                    @click="editOrder(item)"
                  >
                    {{ $t("label.update_order") }}
                    <v-icon right> {{ mdiPencil }} </v-icon>
                  </v-btn>
                  <v-btn
                    color="secondary"
                    small
                    class="ma-2"
                    @click="confirmDelete(item)"
                  >
                    {{ $t("label.delete_order") }}
                    <v-icon right> {{ mdiDelete }} </v-icon>
                  </v-btn>
                  <!-- <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        medium
                        class="mr-2"
                        @click="editOrder(item)"
                      >
                        {{ mdiPencil }}
                      </v-icon>
                    </template>
                    <span>{{ $t("label.update_order") }}</span>
                  </v-tooltip>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        medium
                        @click="confirmDelete(item)"
                      >
                        {{ mdiDelete }}
                      </v-icon>
                    </template>
                    <span>{{ $t("label.delete_order") }}</span>
                  </v-tooltip> -->
                </template>
              </v-data-table>
            </v-card>
            <v-dialog v-model="deleteOrderDialog" width="500" persistent>
              <v-card class="px-1">
                <v-card-title
                  class="headline font-weight-bold dialog-title py-2"
                >
                  {{ $t("label.delete_order") }}
                </v-card-title>
                <v-divider class="py-1"></v-divider>
                {{ $t("message.are_you_sure") }}
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="secondary"
                    small
                    @click="deleteOrder"
                    class="mr-2"
                  >
                    <v-icon>{{ mdiPlus }}</v-icon
                    >{{ $t("label.confirm") }}
                  </v-btn>

                  <v-btn
                    color="secondary"
                    small
                    @click="deleteOrderDialog = false"
                  >
                    <v-icon>{{ mdiClose }}</v-icon
                    >{{ $t("label.cancel") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="updateOrderDialog"
              width="500"
              persistent
              :fullscreen="isFlutter"
            >
              <v-card>
                <v-card-title
                  class="headline font-weight-bold dialog-title py-2"
                >
                  {{ $t("label.update_order") }}
                </v-card-title>
                <v-divider class="py-1"></v-divider>
                <v-text-field
                  v-model="order.CourierNo"
                  :label="$t('label.courier_no')"
                  outlined
                  class="px-2 py-0"
                  :error-messages="CourierNoMsg"
                  v-uppercase
                ></v-text-field>
                <SelectWarehouse
                  class="px-2"
                  v-model="Warehouse"
                  :error-messages="WarehouseMsg"
                  clearable
                  item-text="Warehouse.OriginWhName"
                  item-value="Warehouse.OriginWhCode"
                  :label="$t('label.warehouse')"
                  hide-no-data
                ></SelectWarehouse>

                <div>
                  <v-chip
                    small
                    class="mx-2 my-2"
                    @click="selectProductOption(option)"
                    :key="option"
                    v-for="option in productOptions"
                  >
                    {{ option }}
                  </v-chip>
                </div>

                <v-text-field
                  v-model="order.ProductName"
                  :label="$t('label.product_name')"
                  outlined
                  class="px-2 my-1"
                  :error-messages="ProductNameMsg"
                  v-uppercase
                ></v-text-field>
                <v-text-field
                  v-mask="'#########'"
                  @focus="$event.target.select()"
                  v-model="order.Pkg"
                  :label="$t('label.package')"
                  outlined
                  class="px-2 py-1"
                  :error-messages="PkgMsg"
                ></v-text-field>
                <v-text-field
                  v-model="order.MemberRemark"
                  :label="$t('label.remark')"
                  outlined
                  class="px-2 py-1"
                ></v-text-field>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="secondary"
                    small
                    @click="updateOrder"
                    class="mr-2"
                  >
                    <v-icon>{{ mdiPlus }}</v-icon
                    >{{ $t("label.submit") }}
                  </v-btn>

                  <v-btn color="secondary" small @click="cancelUpdateOrder">
                    <v-icon>{{ mdiClose }}</v-icon
                    >{{ $t("label.cancel") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-tab-item>
          <v-tab-item key="orderTab2">
            <v-container>
              <v-row dense justify="start" class="mt-2">
                <!-- cols => xs -->
                <v-col lg="3" sm="6" cols="12">
                  <SelectWarehouse
                    v-model="GateInWarehouse"
                    ref="selectWarehouse"
                    :label="$t('label.warehouse')"
                    hide-no-data
                    hide-details
                    dense
                  ></SelectWarehouse>
                </v-col>
                <v-col lg="3" sm="6" cols="12">
                  <div class="float-sm-left">
                    <v-btn color="secondary" @click="searchGateInOrder" small
                      ><v-icon>{{ mdiMagnify }}</v-icon
                      >{{ $t("label.search") }}</v-btn
                    >
                    <v-btn
                      class="ml-2 float-right"
                      @click="beforeCheckout"
                      color="secondary"
                      small
                      ><v-icon>{{ mdiCashMultiple }}</v-icon
                      >{{ $t("label.bundle_checkout") }}</v-btn
                    >
                  </div>
                </v-col>
              </v-row>
              <v-dialog
                v-model="checkoutDialog"
                width="640"
                eager
                persistent
                :fullscreen="isFlutter"
              >
                <v-card flat tile class="checkout-dialog">
                  <v-card-title
                    class="headline font-weight-bold dialog-title py-2"
                  >
                    {{ $t("label.bundle_checkout") }} -
                    {{
                      this.GateInWarehouse != null
                        ? this.GateInWarehouse.Name
                        : ""
                    }}
                  </v-card-title>
                  <v-stepper v-model="check">
                    <v-stepper-header>
                      <v-stepper-step step="1" class="py-1">
                        {{ stepTitle1 }}
                      </v-stepper-step>
                      <v-divider></v-divider>
                      <v-stepper-step step="2" class="py-1">
                        {{ stepTitle2 }}
                      </v-stepper-step>
                      <v-divider></v-divider>
                      <v-stepper-step step="3" class="py-1">
                        {{ stepTitle3 }}
                      </v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-content step="1" class="pt-2">
                      <v-card flat class="ma-0 pa-0">
                        <v-expansion-panels class="pb-2">
                          <v-expansion-panel>
                            <v-expansion-panel-header>{{
                              $t("label.order_details")
                            }}</v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-data-table
                                dense
                                :headers="showSelectedOrdersHeaders"
                                :items="gateInSelected"
                                :items-per-page="-1"
                                hide-default-footer
                                disable-sort
                                mobile-breakpoint="320"
                                class="elevation-0"
                                disable-pagination
                              >
                              </v-data-table>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>

                        <v-container class="container-border mb-2">
                          <SelectDistributionCenter
                            class=""
                            v-model="DistributionCenter"
                            hide-details
                            item-text="DistributionCenter.OriginWhName"
                            item-value="DistributionCenter.OriginWhCode"
                            ref="selectDistributionCenter"
                            :label="$t('label.distribution_center')"
                          ></SelectDistributionCenter>
                        </v-container>

                        <v-container class="container-border mb-2">
                          <v-row no-gutters class="px-1 pb-2">
                            <v-col>
                              <v-radio-group
                                class="my-0"
                                hide-details
                                dense
                                v-model="deliveryMethod"
                                row
                                :disabled="disableDeliveryType"
                                @change="resetLocation"
                              >
                                <v-radio
                                  dense
                                  :label="$t('label.direct_delivery')"
                                  value="DIRECT_DELIVERY"
                                ></v-radio>
                                <v-radio
                                  dense
                                  :label="$t('label.self_pick_spot')"
                                  value="SELF_PICKUP_SPOT"
                                ></v-radio>
                              </v-radio-group>
                            </v-col>
                          </v-row>

                          <v-row
                            no-gutters
                            class="px-1 pb-2"
                            v-show="deliveryMethod == 'SELF_PICKUP_SPOT'"
                          >
                            <v-col cols="12" class="pb-2">
                              <SelectZone
                                v-model="Zone"
                                :label="$t('label.zone')"
                                ref="zone"
                                hideDetails
                                :disabled="disableDeliveryType"
                              ></SelectZone>
                            </v-col>
                            <v-col cols="12" class="pb-2">
                              <SelectCity
                                v-model="City"
                                :label="$t('label.city')"
                                ref="city"
                                :itemref="Zone.ZoneName"
                                hideDetails
                                :disabled="disableDeliveryType"
                              ></SelectCity>
                            </v-col>
                          </v-row>

                          <v-row no-gutters class="px-1">
                            <v-col>
                              <SelectMemberAddress
                                class="px-2"
                                v-model="Member"
                                ref="selectMember"
                                v-show="deliveryMethod == 'DIRECT_DELIVERY'"
                                item-text="Member.Address"
                                item-value="Member.ID"
                                :label="$t('label.location')"
                                hide-no-data
                              ></SelectMemberAddress>

                              <SelectSpot
                                class="px-2"
                                v-model="Spot"
                                hide-details
                                :itemref="deliveryMethod"
                                ref="selectSpot"
                                v-show="deliveryMethod == 'SELF_PICKUP_SPOT'"
                                item-text="Spot.OriginWhName"
                                item-value="Spot.OriginWhCode"
                                :zoneName="Zone.ZoneName"
                                :city="City"
                                :label="$t('label.location')"
                                hide-no-data
                                :disabled="disableDeliveryType"
                              ></SelectSpot>
                            </v-col>
                          </v-row>

                          <v-row
                            no-gutters
                            class="px-1 mt-4"
                            v-show="deliveryMethod == 'DIRECT_DELIVERY'"
                          >
                            <v-col>
                              <v-textarea
                                dense
                                hide-details
                                outlined
                                v-model="MemberAddress"
                                readonly
                                ref="MemberAddress"
                                :label="$t('label.address')"
                                rows="1"
                                auto-grow
                              ></v-textarea>
                            </v-col>
                          </v-row>

                          <v-row
                            no-gutters
                            class="px-1 mt-4"
                            v-show="deliveryMethod == 'SELF_PICKUP_SPOT'"
                          >
                            <v-col>
                              <v-textarea
                                dense
                                hide-details
                                outlined
                                v-model="SpotAddress"
                                readonly
                                ref="SpotAddress"
                                :label="$t('label.address')"
                                rows="1"
                                auto-grow
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-container>

                        <v-container class="container-border">
                          <v-row no-gutters class="">
                            <v-col>
                              <v-radio-group
                                dense
                                hide-details
                                v-model="discountType"
                                class="pa-0 ma-0"
                                row
                              >
                                <v-radio
                                  :label="$t('label.none')"
                                  value="NONE"
                                ></v-radio>
                                <v-radio
                                  :label="$t('label.coupon')"
                                  value="COUPON"
                                ></v-radio>
                                <v-radio
                                  :label="$t('label.promo_code')"
                                  value="PROMO_CODE"
                                ></v-radio>
                              </v-radio-group>
                            </v-col>
                          </v-row>

                          <v-row no-gutters class="mt-2">
                            <v-col>
                              <SelectCoupon
                                class="px-2"
                                v-model="Coupon"
                                v-show="discountType == 'COUPON'"
                                item-text="Coupon.CouponName"
                                ref="selectCoupon"
                                :label="$t('label.coupon')"
                              ></SelectCoupon>
                              <v-text-field
                                v-model="PromoCode"
                                :label="$t('label.promo_code')"
                                v-show="discountType == 'PROMO_CODE'"
                                hideDetails
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="secondary"
                            small
                            @click="confirmCheckout"
                          >
                            <v-icon>{{ mdiCheck }}</v-icon
                            >{{ $t("label.confirm") }}
                          </v-btn>
                          <v-btn
                            color="secondary"
                            small
                            @click="closeCheckoutDialog"
                          >
                            <v-icon>{{ mdiClose }}</v-icon
                            >{{ $t("label.cancel") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                      <v-card flat class="mx-0 px-0">
                        <v-row no-gutters class="px-1">
                          <v-col cols="4">
                            {{ $t("label.total_amount") }}
                          </v-col>
                          <v-col cols="8">
                            {{ bundleMsg == null ? "" : bundleMsg.Currency }}
                            ${{ bundleMsg == null ? 0 : bundleMsg.Amount }}
                          </v-col>
                        </v-row>
                        <v-row no-gutters class="px-1">
                          <v-col cols="4">
                            {{ $t("label.discount") }}
                          </v-col>
                          <v-col cols="8">
                            {{ bundleMsg == null ? "" : bundleMsg.Currency }}
                            ${{
                              bundleMsg == null ? 0 : bundleMsg.DiscountAmount
                            }}
                          </v-col>
                        </v-row>
                        <v-row no-gutters class="px-1 font-weight-bold">
                          <v-col cols="4">
                            {{ $t("label.final_amount") }}
                          </v-col>
                          <v-col cols="8">
                            {{ bundleMsg == null ? "" : bundleMsg.Currency }}
                            ${{ bundleMsg == null ? 0 : bundleMsg.FinalAmount }}
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row no-gutters class="px-1">
                          <v-col>
                            {{
                              $t("message.select", {
                                item: $t("label.payment_method"),
                              })
                            }}
                          </v-col>
                        </v-row>
                        <v-row no-gutters class="px-1">
                          <v-col>
                            <v-radio-group dense v-model="paymentMethod">
                              <v-row
                                class="px-0"
                                v-show="showAlipay"
                                align="center"
                              >
                                <v-col cols="2">
                                  <v-radio value="ALIPAY_HK"></v-radio>
                                </v-col>
                                <v-col cols="9"
                                  ><v-img
                                    max-height="50px"
                                    max-width="180px"
                                    contain
                                    src="@/assets/alipay_hk_icon.png"
                                    position="left center"
                                  ></v-img>
                                </v-col>
                              </v-row>
                              <v-row class="px-0"> </v-row>
                              <v-row
                                class="px-0"
                                v-show="showPayme"
                                align="center"
                              >
                                <v-col cols="2">
                                  <v-radio value="HSBC_PAYME"></v-radio>
                                </v-col>
                                <v-col cols="9"
                                  ><v-img
                                    max-height="50px"
                                    max-width="180px"
                                    contain
                                    src="@/assets/payme_logo1.png"
                                    position="left center"
                                  ></v-img>
                                </v-col>
                              </v-row>
                            </v-radio-group>
                          </v-col>
                        </v-row>
                        <v-row
                          no-gutters
                          class="px-1"
                          v-show="
                            this.isMobileWeb() && paymentMethod == 'HSBC_PAYME'
                          "
                        >
                          {{ $t("message.selected_payme") }}
                        </v-row>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="secondary"
                            small
                            @click="confirmPayment"
                          >
                            <v-icon>{{ mdiCheck }}</v-icon
                            >{{ $t("label.confirm") }}
                          </v-btn>
                          <v-btn
                            color="secondary"
                            small
                            @click="closeCheckoutDialog"
                          >
                            <v-icon>{{ mdiClose }}</v-icon
                            >{{ $t("label.cancel") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                      <v-card flat class="mx-0 px-0">
                        <v-row no-gutters class="px-5">
                          <v-col>
                            {{ $t("message.complete_checkout") }}
                          </v-col>
                        </v-row>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="secondary"
                            small
                            @click="closeCheckoutDialog"
                          >
                            <v-icon>{{ mdiClose }}</v-icon
                            >{{ $t("label.complete") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-stepper-content>
                  </v-stepper>
                </v-card>
              </v-dialog>

              <v-data-table
                v-model="gateInSelected"
                show-select
                :single-select="gateInSingleSelect"
                :headers="gateInheaders"
                :items="gateInOrders"
                item-key="OrderNo"
                hide-default-footer
                :disable-sort="$vuetify.breakpoint.smAndDown"
                class="elevation-2 mt-3 gate-in-orders"
                disable-pagination
                lang="zh"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn
                    color="secondary"
                    small
                    class="ma-2"
                    @click="editGatedInOrder(item)"
                  >
                    {{ $t("label.update_order") }}
                    <v-icon right> {{ mdiPencil }} </v-icon>
                  </v-btn>
                </template>

                <!-- <template slot="body.append">
                    <tr class="pink--text">
                        <th class="title">Totals</th>
                        <th class="title">{{ 0 }}</th>
                        <th class="title">{{ 1 }}</th>
                        <th class="title">{{ 2 }}</th>
                        <th class="title">{{ 3 }}</th>
                    </tr>
                </template> -->

                <template slot="body.append" v-if="$vuetify.breakpoint.xs">
                  <div class="grey lighten-3 px-6 font-weight-black subtitle-1">
                    <label class="float-left">{{
                      $t("label.total_checked_chg_weight")
                    }}</label>
                    <label class="float-right">{{
                      totalGateInSelected.ChgWgt
                    }}</label>
                  </div>
                  <div class="grey lighten-3 px-6 font-weight-black subtitle-1">
                    <label class="float-left">{{
                      $t("label.total_checked_weight")
                    }}</label>
                    <label class="float-right">{{
                      totalGateInSelected.Wgt
                    }}</label>
                  </div>
                </template>
                <template slot="body.append" v-else>
                  <tr class="grey lighten-3 font-weight-black">
                    <th />
                    <th
                      v-for="(header, i) in gateInheaders"
                      :key="i"
                      class="subtitle-2"
                    >
                      <div v-if="header.value == 'ChgWgt'">
                        {{ totalGateInSelected.ChgWgt }}
                      </div>
                      <div v-if="header.value == 'Wgt'">
                        {{ totalGateInSelected.Wgt }}
                      </div>
                      <div v-if="header.value == 'Pkg'">
                        {{ totalGateInSelected.Pkg }}
                      </div>
                      <div v-else-if="i == 0">
                        {{ $t("label.total_checked") }}
                      </div>
                      <div v-else></div>
                    </th>
                  </tr>
                </template>
              </v-data-table>
              <v-dialog
                v-model="updateGatedInOrderDialog"
                width="500"
                persistent
                :fullscreen="isFlutter"
              >
                <v-card>
                  <v-card-title
                    class="headline font-weight-bold dialog-title py-2"
                  >
                    {{ $t("label.update_order") }}
                  </v-card-title>
                  <v-divider class="py-1"></v-divider>
                  <v-text-field
                    disabled
                    v-model="gatedInOrder.CourierNo"
                    :label="$t('label.courier_no')"
                    outlined
                    class="px-2 py-0"
                    :error-messages="CourierNoMsg"
                    v-uppercase
                  ></v-text-field>

                  <div>
                    <v-chip
                      small
                      class="mx-2 mb-2"
                      @click="selectProductOption(option, true)"
                      :key="option"
                      v-for="option in productOptions"
                    >
                      {{ option }}
                    </v-chip>
                  </div>

                  <v-text-field
                    v-model="gatedInOrder.ProductName"
                    :label="$t('label.product_name')"
                    outlined
                    class="px-2 my-1"
                    :error-messages="ProductNameMsg"
                    v-uppercase
                  ></v-text-field>
                  <v-text-field
                    v-model="gatedInOrder.MemberRemark"
                    :label="$t('label.remark')"
                    outlined
                    class="px-2 py-1"
                  ></v-text-field>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="secondary"
                      small
                      @click="updateGatedInOrder"
                      class="mr-2"
                    >
                      <v-icon>{{ mdiPlus }}</v-icon
                      >{{ $t("label.submit") }}
                    </v-btn>

                    <v-btn
                      color="secondary"
                      small
                      @click="cancelUpdateGatedInOrder"
                    >
                      <v-icon>{{ mdiClose }}</v-icon
                      >{{ $t("label.cancel") }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-container>
          </v-tab-item>
          <v-tab-item key="bundleTab1">
            <v-card flat>
              <v-data-table
                :headers="processingHeaders"
                :items="processingBundles"
                :items-per-page="10"
                item-key="BundleNo"
                :server-items-length="totalProcessingBundles"
                :page="processingBundlePage"
                :options.sync="processingBundleOptions"
                :loading="loadingBundles"
                class="elevation-1"
                :single-expand="true"
                show-expand
              >
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length" class="mx-0 px-0">
                    <v-data-table
                      :headers="orderViewHeaders"
                      :items="item.OrderViews"
                      dense
                      hide-default-footer
                      class="elevation-4"
                    >
                    </v-data-table>
                  </td>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn
                    color="secondary"
                    small
                    class="ma-2"
                    @click="showMap(item)"
                    v-if="item.DeliveryType == 'SELF_PICKUP_SPOT' && isFlutter"
                  >
                    {{ $t("label.map") }}
                    <v-icon right> {{ mdiMapMarker }} </v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
          <v-tab-item key="bundleTab3">
            <v-card flat>
              <v-data-table
                :headers="deliveredHeaders"
                :items="deliveredBundles"
                :items-per-page="10"
                item-key="BundleNo"
                :server-items-length="totalDeliveredBundles"
                :page="deliveredBundlePage"
                :options.sync="deliveredBundleOptions"
                :loading="loadingBundles"
                class="elevation-1"
                :single-expand="true"
                show-expand
              >
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length" class="mx-0 px-0">
                    <v-data-table
                      :headers="orderViewHeaders"
                      :items="item.OrderViews"
                      dense
                      hide-default-footer
                      class="elevation-4"
                    >
                    </v-data-table>
                  </td>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn
                    color="secondary"
                    small
                    class="ma-2"
                    @click="showImageViewer(item)"
                  >
                    {{ $t("label.image") }}
                    <v-icon right> {{ mdiImage }} </v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
          <v-tab-item key="claimCargoTab4">
            <claim-cargo flat></claim-cargo>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

    <v-snackbar
      v-model="snackbar"
      :timeout="snackbarTimeout"
      :color="snackbarColor"
    >
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn icon @click="snackbar = false" v-bind="attrs">
          <v-icon>{{ mdiClose }}</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog
      v-model="loading"
      persistent
      fullscreen
      content-class="loading-dialog"
    >
      <v-container fill-height>
        <v-layout row justify-center align-center>
          <v-progress-circular
            indeterminate
            :size="70"
            :width="7"
            color="primary"
          ></v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>

    <v-dialog v-model="customDeclarationDialog" persistent max-width="320">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ $t("message.are_you_sure") }}
        </v-card-title>
        <v-card-text class="font-weight-bold mt-3">{{
          $t("message.custom_declaration")
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" small @click="openCheckoutDialog">
            <v-icon>{{ mdiCheck }}</v-icon
            >{{ $t("label.confirm") }}
          </v-btn>
          <v-btn
            color="secondary"
            small
            @click="customDeclarationDialog = false"
          >
            <v-icon>{{ mdiClose }}</v-icon
            >{{ $t("label.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <image-viewer-dialog
      v-model="showImageDialog"
      width="500"
      :docType="imageDocType"
      :docNo="imageDocNo"
    >
    </image-viewer-dialog>
  </v-container>
</template>

<script>
import {
  mdiPlus,
  mdiClose,
  mdiRefresh,
  mdiPencil,
  mdiDelete,
  mdiMagnify,
  mdiCashMultiple,
  mdiCheck,
  mdiMapMarker,
  mdiImage,
} from "@mdi/js";
import i18n from "../lang/lang";
import SelectWarehouse from "@/components/Select/SelectWarehouse.vue";
import SelectDistributionCenter from "@/components/Select/SelectDistributionCenter.vue";
import SelectZone from "@/components/Select/SelectZone.vue";
import SelectCity from "@/components/Select/SelectCity.vue";
import SelectSpot from "@/components/Select/SelectSpot.vue";
import SelectMemberAddress from "@/components/Select/SelectMemberAddress.vue";
import SelectCoupon from "@/components/Select/SelectCoupon.vue";
import {
  AddOrder,
  SearchOrder,
  UpdateOrder,
  UpdateGatedInOrder,
  VoidOrder,
  AddBundle,
  UpdatePaymentMethod,
  Checkout,
  SearchBundle,
  InquiryPayment,
  GetSelfPickupSpotByNo,
  MustUsePickup,
} from "@/api/publicServices";
import AlipayDialog from "./payment/AlipayDialog.vue";
import PaymeDialog from "./payment/PaymeDialog.vue";
import PollingDialog from "./payment/PollingDialog.vue";
import ClaimCargo from "./ClaimCargo.vue";
import ImageViewerDialog from "./ImageViewerDialog.vue";

export default {
  metaInfo: {
    title: "訂單",
    titleTemplate: "%s | 控制台 | 青蛙集運",
  },
  data: () => ({
    check: 1,
    tab: 1, //set gate in as default
    stepTitle1: "",
    stepTitle2: "",
    stepTitle3: "",
    discountType: "NONE",
    deliveryMethod: "DIRECT_DELIVERY",
    paymentMethod: "HSBC_PAYME",
    pendingOrders: [],
    gateInOrders: [],
    title: "label.order",
    addOrderDialog: false,
    checkoutDialog: false,
    order: null,
    Warehouse: null,
    GateInWarehouse: { CenterNo: "", Name: "" },
    DistributionCenter: null,
    Spot: {
      Address: "",
    },
    Member: {
      ID: "",
      ShortCode: "",
      Address: "",
    },
    CourierNoMsg: "",
    WarehouseMsg: "",
    ProductNameMsg: "",
    PkgMsg: "",
    snackbar: false,
    snackbarColor: "secondary",
    snackbarTimeout: 10000,
    text: "",
    gateInSingleSelect: false,
    gateInSelected: [],
    Address: "",
    SpotAddress: "",
    MemberAddress: "",
    bundle: null,
    bundleMsg: null,
    Coupon: null,
    PromoCode: "",
    defaultDestinationWarehouse: null,
    defaultOriginWarehouse: null,
    isAlreadyGetDefault: false,
    preDeleteOrder: null,
    deleteOrderDialog: false,
    updateOrderDialog: false,
    updateGatedInOrderDialog: false,
    gatedInOrder: { CourierNo: "", ProductName: "", MemberRemark: "" },
    showAlipay: false,
    showPayme: false,
    loading: false,
    customDeclarationDialog: false,
    //diabled delivery type & select pickup when mustusepickup=1
    disableDeliveryType:false,
    //alipay-dialog
    showAlipayQrForm: false,
    alipayHeader: "",
    alipayPaymentId: "",
    alipayUrl: "",
    //payme-dialog
    showPaymeQrForm: false,
    paymeDialogConfig: {
      header: "",
      paymentId: "",
      url: "",
      logoUrl: "",
    },
    //polling payment dialog
    showPollingDialog: false,
    pollingDialogConfig: {
      paymentId: "",
      interval: 0,
    },

    //product name options
    //["家品", "文具", "服飾", "電器", "手機配件"],
    productOptions: ["衣服", "鞋", "家庭用品", "浴室用品", "裝飾品", "家電", "手機配件", "個人護理品", "汽車配件", "母嬰用品", "廚房用品", "家具", "玩具", "文具", "電腦配件", "燈飾", "戶外用品", "手飾"],

    //bundle
    processingBundles: [],
    readyBundles: [],
    deliveredBundles: [],
    processingBundlePageSize: 10,
    processingBundlePage: 1,
    processingBundleOptions: {},
    totalProcessingBundles: 0,
    readyBundlePageSize: 10,
    readyBundlePage: 1,
    readyBundleOptions: {},
    totalReadyBundles: 0,
    deliveredBundlePageSize: 10,
    deliveredBundlePage: 1,
    deliveredBundleOptions: {},
    totalDeliveredBundles: 0,
    loadingBundles: false,

    //zone, city
    Zone: {
      ZoneName: "",
    },
    City: {},

    //image dialog
    showImageDialog: false,
    imageDocType: "",
    imageDocNo: "",

    //svg icons
    mdiPlus,
    mdiClose,
    mdiRefresh,
    mdiPencil,
    mdiDelete,
    mdiMagnify,
    mdiCashMultiple,
    mdiCheck,
    mdiMapMarker,
    mdiImage,
  }),
  components: {
    SelectWarehouse: SelectWarehouse,
    SelectDistributionCenter: SelectDistributionCenter,
    SelectSpot: SelectSpot,
    SelectZone: SelectZone,
    SelectCity: SelectCity,
    SelectMemberAddress: SelectMemberAddress,
    SelectCoupon: SelectCoupon,
    PollingDialog: PollingDialog,
    AlipayDialog: AlipayDialog,
    PaymeDialog: PaymeDialog,
    ClaimCargo: ClaimCargo,
    ImageViewerDialog: ImageViewerDialog,
  },
  methods: {
    selectProductOption(option, gateIn) {
      console.log(option);
      if (gateIn) {
        this.gatedInOrder.ProductName = option;
      } else {
        this.order.ProductName = option;
      }
    },
    showImageViewer(bundle) {
      console.log(bundle);
      this.imageDocType = "SIGNBACK";
      this.imageDocNo = bundle.BundleNo;
      this.showImageDialog = true;
    },
    async showMap(bundle) {
      try {
        const param = { CenterNo: bundle.CenterNo };
        const response = await GetSelfPickupSpotByNo(param);
        let lat = response.data.Latitude;
        let lng = response.data.Longitude;
        let title = `青蛙集運-${response.data.Name}`;
        let type = "1";
        if (lat == 0 && lng == 0) {
          this.text = i18n.t("message.invalid_gps");
          this.snackbarColor = "red";
          this.snackbarTimeout = 10000;
          this.snackbar = true;
          return;
        }
        if (this.isFlutter) {
          window.flutter_inappwebview.callHandler("flutterMapHandler", {
            lat,
            lng,
            title,
            type,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    refreshOrder() {
      if (this.tab == 0) {
        this.searchOrder("ORDER_PENDING");
      } else if (this.tab == 1) {
        this.searchOrder("ORIGIN_IN");
      } else if (this.tab == 2) {
        this.searchBundle("PROCESSING");
      } else if (this.tab == 3) {
        this.searchBundle("DELIVERED");
      }
    },
    // testAlipayQrCode() {
    //   this.showAlipayQrForm = true;
    //   this.alipayHeader = `${i18n.t("label.total")}: ${
    //     this.bundleMsg == null ? "" : this.bundleMsg.Currency
    //   } ${this.bundleMsg == null ? 0 : this.bundleMsg.FinalAmount}`;
    //   this.alipayPaymentId = "698DB82E-8651-EC11-941E-000C29A44FB6";
    //   this.alipayUrl =
    //     "https://mapi-hk.alipay.com/gateway.do?_input_charset=UTF-8&currency=HKD&notify_url=https%3A%2F%2Fapi.codpayment.com%2Falipay-aboss%2Fnotify%2Fonline%2F3015211108162428%2F6863936581%2F698DB82E-8651-EC11-941E-000C29A44FB6&order_gmt_create=2021-11-30%2010%3A38%3A18&order_valid_time=43200&out_trade_no=20211130103818322824654&partner=2088031603876323&payment_inst=ALIPAYHK&product_code=NEW_WAP_OVERSEAS_SELLER&qr_pay_mode=4&qrcode_width=200&secondary_merchant_id=3015211108162428&secondary_merchant_industry=4215&secondary_merchant_name=SUPEX%20LOGIC%20(HONGKONG)%20LIMITED&service=create_forex_trade&subject=Freight%20Rate(%E9%81%8B%E8%B2%BB)%20-%20BFG000111&total_fee=0.1&sign=JXlwAEvyfpjP0v9hlCNZKgp80h7i5E%2FnL5mP%2FHXxZW%2FTz9tl3izaRqB69oNE5bqyVI9qrjt0w6K%2Bw63KOf4OjyWpj7AsBJX1b8vd0ssd5aYKPp8Ix1fcFsGOR%2FHZejR9BTjC0ApJqbgqhWEiET2f5r4fF92wcqDoKoa2XGBHb32nVYeL%2B0%2FOldnVBgvLPm2JvGxSDygXb7cQTr2qjAG9PczrXzXhXvt1GhI0E%2BxjvBztn1yXy7ke93%2FDrrBEwT8YsZ8wxqPhANUL36yGHUKqnNClvyHJV9JC9ITPCN1OvqEfr%2FAlfBxaFPY8LTtqx5yNPvfTrcVfrtd0Qiv6sb%2FhNw%3D%3D&sign_type=RSA2";
    // },
    // testPaymeQrCode() {
    //   this.showPaymeQrForm = true;
    //   this.paymeDialogConfig.header = `${i18n.t("label.total")}: 18.18`;
    //   this.paymeDialogConfig.paymentId = "698DB82E-8651-EC11-941E-000C29A44FB6";
    //   this.paymeDialogConfig.url =
    //     "https://sacctprodmobsandbox.z7.web.core.windows.net//8dca9057-81ca-429f-bd3d-dd88a69a9946";
    //   this.paymeDialogConfig.logoUrl =
    //     "https://shopfront.paymebiz.hsbc.com.hk/onboarding/df45d63700123b08cdbd5e7cf7c4264eb40abdf1dced3b2464e5a74d3d42a8f8/businessLogo_60x60.png";
    //   this.$nextTick(() => {
    //     console.log("nextTick");
    //     this.$refs.paymeDialog.updateQrcode();
    //   });

    //   console.log(this.paymeDialogConfig);
    // },
    async searchGateInOrder() {
      this.searchOrder("ORIGIN_IN");
    },
    async searchOrder(status) {
      this.pendingOrders = [];
      this.gateInOrders = [];
      this.bundleOrders = [];
      try {
        let data = { Status: status };
        if (status == "ORIGIN_IN") {
          if (this.$refs.selectWarehouse) {
            let serviceCenter = this.$refs.selectWarehouse.getWarehouse();
            if (serviceCenter != null) {
              this.GateInWarehouse = serviceCenter;
            }
          }
          if (
            this.GateInWarehouse == null ||
            this.GateInWarehouse.CenterNo == ""
          ) {
            return;
          }
          data["OriginWhCode"] = this.GateInWarehouse.CenterNo;
        }
        const response = await SearchOrder(data);
        if (status == "ORIGIN_IN") {
          this.gateInOrders = response.data;
        } else {
          this.pendingOrders = response.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async addOrder(e) {
      e.preventDefault();

      this.CourierNoMsg = "";
      this.WarehouseMsg = "";
      this.ProductNameMsg = "";
      this.PkgMsg = "";

      if (this.Warehouse == null) {
        this.WarehouseMsg = i18n.t("message.required");
        return;
      }
      if (this.order.Pkg == "" || this.order.Pkg == 0) {
        this.PkgMsg = i18n.t("message.cannot_zero");
        return;
      }
      if (this.order.ProductName == "") {
        this.ProductNameMsg = i18n.t("message.required");
        return;
      }
      if (this.order.CourierNo == "") {
        this.CourierNoMsg = i18n.t("message.required");
        return;
      }
      try {
        this.order.OriginWhCode = this.Warehouse.CenterNo;
        this.order.OriginWhName = this.Warehouse.Name;
        const response = await AddOrder({ Order: this.order });

        if (response.data.isSuccess) {
          this.text = i18n.t("message.create_order_success", {
            order_no: response.data.Key,
          });
          this.snackbarColor = "secondary";
          this.snackbarTimeout = 10000;
          this.snackbar = true;
          this.addOrderDialog = false;
          this.searchOrder("ORDER_PENDING");
        } else {
          this.text = response.data.Msg;
          this.snackbarColor = "red";
          this.snackbarTimeout = 10000;
          this.snackbar = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    beforeCheckout() {
      if (this.GateInWarehouse == null || this.GateInWarehouse.CenterNo == "") {
        this.text = i18n.t("message.select", {
          item: i18n.t("label.warehouse"),
        });
        this.snackbarColor = "red";
        this.snackbarTimeout = 10000;
        this.snackbar = true;
        return;
      }

      if (this.gateInSelected == 0) {
        this.text = i18n.t("message.select", { item: i18n.t("label.order") });
        this.snackbarColor = "red";
        this.snackbarTimeout = 10000;
        this.snackbar = true;
        return;
      }
      console.log(this.gateInSelected);
      let validProductName = this.gateInSelected.every((x) => x.ProductName);
      console.log(validProductName);
      if (!validProductName) {
        this.text = i18n.t("message.is_empty", {
          type: i18n.t("label.product_name"),
        });
        console.log(this.text);
        this.snackbarColor = "red";
        this.snackbarTimeout = 10000;
        this.snackbar = true;
        return;
      }
      this.customDeclarationDialog = true;
    },
    async openCheckoutDialog() {
      this.customDeclarationDialog = false;
      this.check = 1;
      this.checkoutDialog = true;
      this.resetBundling();
      const response = await MustUsePickup({});
      console.log('openCheckoutDialog', response.data);
      if (response.data) {
        this.disableDeliveryType=true;
        this.deliveryMethod="SELF_PICKUP_SPOT";
      }
    },
    closeCheckoutDialog() {
      this.searchOrder("ORIGIN_IN");
      this.checkoutDialog = false;
      this.gateInSelected = [];
    },
    resetLocation() {
      this.$refs.selectSpot.resetLocation();
    },
    resetBundling() {
      this.stepTitle1 = i18n.t("label.input_detail");
      this.stepTitle2 = i18n.t("label.select_payment_method");
      this.stepTitle3 = i18n.t("label.complete");
      this.DistributionCenter = null;
      this.Spot = { Address: "" };
      this.Coupon = null;
      this.PromoCode = "";
      this.deliveryMethod = "DIRECT_DELIVERY";
      if (this.$refs.zone) {
        this.$refs.zone.reset();
      }
      if (this.$refs.city) {
        this.$refs.city.reset();
      }
      if (this.$refs.selectSpot) {
        this.$refs.selectSpot.resetLocation();
      }
      if (this.$refs.selectMember) {
        this.$refs.selectMember.setDefault();
      }
      if (this.$refs.selectDistributionCenter) {
        this.$refs.selectDistributionCenter.setDefault();
      }
      if (this.$refs.selectCoupon) {
        this.$refs.selectCoupon.resetCoupon();
      }
    },
    async confirmCheckout() {
      if (
        this.DistributionCenter == null ||
        this.DistributionCenter.CenterNo == ""
      ) {
        this.text = i18n.t("message.select", {
          item: i18n.t("label.distribution_center"),
        });
        this.snackbarColor = "red";
        this.snackbarTimeout = 10000;
        this.snackbar = true;
        return;
      }

      let Bundle = {};
      Bundle.OriginWhCode = this.GateInWarehouse.CenterNo;
      Bundle.OriginWhName = this.GateInWarehouse.Name;
      Bundle.OriginWhAdd = this.GateInWarehouse.Address;
      Bundle.DestWhCode = this.DistributionCenter.CenterNo;
      Bundle.DestWhName = this.DistributionCenter.Name;
      Bundle.DestWhAdd = this.DistributionCenter.Address;
      Bundle.DeliveryType = this.deliveryMethod;

      Bundle.CenterNo = "";
      Bundle.CenterName = "";
      Bundle.CenterAdd = "";
      Bundle.MemberAddID = "";
      Bundle.MemberAdd = "";

      if (this.deliveryMethod == "DIRECT_DELIVERY") {
        if (this.Member == null || this.Member.ID == "") {
          this.text = i18n.t("message.select", {
            item: i18n.t("label.location"),
          });
          this.snackbarColor = "red";
          this.snackbarTimeout = 10000;
          this.snackbar = true;
          return;
        }
        Bundle.MemberAddID = this.Member.ID;
        Bundle.MemberAdd = this.Member.Address;
      } else if (this.deliveryMethod == "SELF_PICKUP_SPOT") {
        if (this.Spot == null || this.Spot.CenterNo == "") {
          this.text = i18n.t("message.select", {
            item: i18n.t("label.location"),
          });
          this.snackbarColor = "red";
          this.snackbarTimeout = 10000;
          this.snackbar = true;
          return;
        }

        Bundle.CenterNo = this.Spot.CenterNo;
        Bundle.CenterName = this.Spot.Name;
        Bundle.CenterAdd = this.Spot.Address;
      } else {
        this.text = i18n.t("message.select", { item: i18n.t("label.service") });
        this.snackbarColor = "red";
        this.snackbarTimeout = 10000;
        this.snackbar = true;
        return;
      }

      let OrderNos = [];
      for (let index in this.gateInSelected) {
        OrderNos.push(this.gateInSelected[index].OrderNo);
      }

      let data = { Bundle: Bundle, OrderNos: OrderNos };

      if (this.discountType == "COUPON") {
        if (this.Coupon == null) {
          this.text = i18n.t("message.select", {
            item: i18n.t("label.coupon"),
          });
          this.snackbarColor = "red";
          this.snackbarTimeout = 10000;
          this.snackbar = true;
          return;
        }
        data.CouponDistID = this.Coupon.DistID;
      } else if (this.discountType == "PROMO_CODE") {
        if (this.PromoCode.trim() == "") {
          this.text = i18n.t("message.select", {
            item: i18n.t("label.promo_code"),
          });
          this.snackbarColor = "red";
          this.snackbarTimeout = 10000;
          this.snackbar = true;
          return;
        }
        data.PromoCode = this.PromoCode;
      }

      try {
        this.loading = true;
        const response = await AddBundle(data);
        this.loading = false;
        if (response.data.isSuccess) {
          this.bundle = response.data;
          this.bundleMsg = JSON.parse(this.bundle.Msg);
          this.check = 2;
          this.showAlipay = true;
          this.showPayme = true;
          // if (localStorage["member_no"].toUpperCase() == "TEST") {
          // }
          this.paymentMethod = "ALIPAY_HK";
        } else {
          this.text = response.data.Msg;
          this.snackbarColor = "red";
          this.snackbarTimeout = 10000;
          this.snackbar = true;
        }
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    async confirmPayment() {
      let PaymentID = this.bundle.Key;
      let data = {
        PaymentMethod: this.paymentMethod,
        PaymentID: this.bundle.Key,
      };

      try {
        this.loading = true;
        const response = await UpdatePaymentMethod(data);
        if (response.data.isSuccess) {
          if (response.data.Key == "PAID") {
            this.check = 3;
            this.resetBundling();
          } else if (this.paymentMethod == "HSBC_PAYME") {
            localStorage.setItem("PaymentID", PaymentID);
            localStorage.setItem("PaymentMethod", this.paymentMethod);
            this.checkout(PaymentID);
          } else if (this.paymentMethod == "ALIPAY_HK") {
            localStorage.setItem("PaymentID", PaymentID);
            localStorage.setItem("PaymentMethod", this.paymentMethod);
            this.checkout(PaymentID);
          }
        } else {
          this.text = response.data.Msg;
          this.snackbarColor = "red";
          this.snackbarTimeout = 10000;
          this.snackbar = true;
          this.loading = false;
        }
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    async checkout(PaymentID) {
      try {
        let RedirectUrl = window.location.href + "?PaymentID=" + PaymentID;

        let data = {
          PaymentID: PaymentID,
          RedirectUrl: RedirectUrl,
          Flutter: this.isFlutter,
        };

        const response = await Checkout(data);
        this.loading = false;
        if (response.data.isSuccess) {
          console.log(response.data);
          if (this.paymentMethod == "ALIPAY_HK") {
            console.log(response.data);
            if (this.isFlutter) {
              try {
                window.flutter_inappwebview.callHandler(
                  "flutterPaymentHandler",
                  {
                    type: this.paymentMethod,
                    data: {
                      url: response.data.Key,
                      paymentId: PaymentID,
                    },
                  }
                );
              } catch (error) {
                console.log(error);
              }
            } else if (this.isMobileWeb()) {
              window.location.href = response.data.Key;
            } else {
              this.alipayUrl = response.data.Key;
              console.log(this.bundleMsg);
              this.alipayHeader = `${i18n.t("label.total")}: ${
                this.bundleMsg == null ? "" : this.bundleMsg.Currency
              } ${this.bundleMsg == null ? 0 : this.bundleMsg.FinalAmount}`;
              this.alipayPaymentId = PaymentID;
              this.showAlipayQrForm = true;
            }
          } else if (this.paymentMethod == "HSBC_PAYME") {
            console.log(response.data);
            if (this.isFlutter) {
              try {
                window.flutter_inappwebview.callHandler(
                  "flutterPaymentHandler",
                  {
                    type: this.paymentMethod,
                    data: {
                      url: response.data.Key,
                      paymentId: PaymentID,
                    },
                  }
                );
              } catch (error) {
                console.log(error);
              }
            } else if (this.isMobileWeb()) {
              //window.location.replace(response.data.Key);
              window.location.href = response.data.Key;
            } else {
              let data = JSON.parse(response.data.Msg);
              this.paymeDialogConfig.url = response.data.Key;
              this.paymeDialogConfig.logoUrl = data.businessLogos.normal;

              console.log(this.bundleMsg);
              this.paymeDialogConfig.header = `${i18n.t("label.total")}: ${
                this.bundleMsg == null ? "" : this.bundleMsg.Currency
              } ${this.bundleMsg == null ? 0 : this.bundleMsg.FinalAmount}`;
              this.paymeDialogConfig.paymentId = PaymentID;
              console.log(this.paymeDialogConfig);
              this.showPaymeQrForm = true;
              this.$nextTick(() => {
                console.log("nextTick");
                this.$refs.paymeDialog.updateQrcode();
              });
            }
          }
        } else {
          this.text = response.data.Msg;
          this.snackbarColor = "red";
          this.snackbarTimeout = 10000;
          this.snackbar = true;
        }
      } catch (error) {
        this.text = "Service Error";
        this.snackbarColor = "red";
        this.snackbarTimeout = 10000;
        this.snackbar = true;
        console.log(error);
        this.loading = false;
      }
    },
    async inquiryPayment(paymentId) {
      try {
        let data = { PaymentID: paymentId };
        this.loading = true;
        const response = await InquiryPayment(data);
        this.loading = false;
        if (response.data.isSuccess) {
          this.check = 3;
          this.resetBundling();
          return true;
        }
      } catch (error) {
        this.loading = false;
        this.text = "Service Error";
        this.snackbarColor = "red";
        this.snackbarTimeout = 10000;
        this.snackbar = true;
        console.log(error);
      }
    },
    afterAlipayFinished(data) {
      console.log("afterAlipayFinished", data);
      if (data.paymentStatus) {
        this.resetAlipayDialog();
        this.check = 3;
      } else {
        this.text = i18n.t("message.payment_failed");
        this.snackbarColor = "red";
        this.snackbarTimeout = -1;
        this.snackbar = true;
      }
    },
    afterPaymeFinished(data) {
      console.log("afterPaymeFinished", data);
      if (data.paymentStatus) {
        this.resetPaymeDialog();
        if (data.paymentStatus) {
          this.check = 3;
        }
      } else {
        //this.text = i18n.t("message.payment_failed");
        if (data.failMsg != "") {
          this.text = data.failMsg;
        } else {
          this.text = i18n.t("message.payment_failed");
        }
        this.snackbarColor = "red";
        this.snackbarTimeout = -1;
        this.snackbar = true;
      }
    },
    afterPaymentPollingFinished(data) {
      console.log("afterPaymentPollingFinished", data);
      this.pollingDialogConfig = {
        paymentId: "",
        interval: 0,
      };
      if (data.paymentStatus) {
        this.check = 3;
      } else {
        this.text = i18n.t("message.payment_failed");
        this.snackbarColor = "red";
        this.snackbarTimeout = -1;
        this.snackbar = true;
      }
    },
    resetAlipayDialog() {
      this.alipayUrl = "";
      this.alipayHeader = "";
      this.alipayPaymentId = "";
    },
    resetPaymeDialog() {
      this.paymeDialogConfig = {
        url: "",
        header: "",
        paymentId: "",
        logoUrl: "",
      };
    },
    openAddOrderDialog() {
      this.addOrderDialog = true;
      this.order = this.resetNewOrder();
    },

    resetNewOrder() {
      return {
        CourierNo: "",
        Pkg: 0,
        OriginWhCode: "",
        OriginWhName: "",
        ProductName: "",
      };
    },
    cancelUpdateOrder() {
      this.updateOrderDialog = false;
      this.searchOrder("ORDER_PENDING");
    },
    async editOrder(order) {
      this.updateOrderDialog = true;
      this.order = order;
    },
    confirmDelete(order) {
      this.deleteOrderDialog = true;
      this.preDeleteOrder = order;
    },

    async deleteOrder() {
      try {
        const response = await VoidOrder({
          OrderNo: this.preDeleteOrder.OrderNo,
        });
        if (response.data.isSuccess) {
          this.searchOrder("ORDER_PENDING");
          this.text = i18n.t("message.update_success");
          this.snackbarColor = "secondary";
          this.snackbarTimeout = 10000;
          this.snackbar = true;
        } else {
          this.text = response.data.Msg;
          this.snackbarColor = "red";
          this.snackbarTimeout = 10000;
          this.snackbar = true;
        }
        this.deleteOrderDialog = false;
      } catch (error) {
        console.log(error);
      }
    },
    async updateOrder() {
      try {
        const response = await UpdateOrder({ Order: this.order });
        if (response.data.isSuccess) {
          this.searchOrder("ORDER_PENDING");
          this.text = i18n.t("message.update_success");
          this.snackbarColor = "secondary";
          this.snackbarTimeout = 10000;
          this.snackbar = true;
        } else {
          this.text = response.data.Msg;
          this.snackbarColor = "red";
          this.snackbarTimeout = 10000;
          this.snackbar = true;
        }
        this.updateOrderDialog = false;
      } catch (error) {
        console.log(error);
      }
    },
    editGatedInOrder(order) {
      this.updateGatedInOrderDialog = true;
      this.gatedInOrder = { ...order };
      console.log(this.gatedInOrder);
    },
    cancelUpdateGatedInOrder() {
      this.updateGatedInOrderDialog = false;
    },
    async updateGatedInOrder() {
      try {
        if (!this.gatedInOrder.ProductName) {
          this.text = i18n.t("message.is_empty", {
            type: i18n.t("label.product_name"),
          });
          this.snackbarColor = "red";
          this.snackbarTimeout = 10000;
          this.snackbar = true;
          return;
        }

        const response = await UpdateGatedInOrder({ Order: this.gatedInOrder });
        if (response.data.isSuccess) {
          //this.searchOrder('ORIGIN_IN');
          //gateInOrders
          let foundIndex = this.gateInOrders.findIndex((item) => {
            return item.OrderNo === this.gatedInOrder.OrderNo;
          });
          foundIndex > -1 &&
            this.gateInOrders.splice(foundIndex, 1, this.gatedInOrder);
          //gateInSelected
          foundIndex = this.gateInSelected.findIndex((item) => {
            return item.OrderNo === this.gatedInOrder.OrderNo;
          });
          foundIndex > -1 &&
            this.gateInSelected.splice(foundIndex, 1, this.gatedInOrder);

          this.text = i18n.t("message.update_success");
          this.snackbarColor = "secondary";
          this.snackbarTimeout = 10000;
          this.snackbar = true;
        } else {
          this.text = response.data.Msg;
          this.snackbarColor = "red";
          this.snackbarTimeout = 10000;
          this.snackbar = true;
        }
        this.updateGatedInOrderDialog = false;
      } catch (error) {
        console.log(error);
      }
    },
    async searchBundle(status) {
      try {
        let data = {};
        data.Status = status;
        this.loadingBundles = true;
        if (status == "PROCESSING") {
          data.PageSize = this.processingBundlePageSize;
          data.PageNum = this.processingBundleOptions.page;
        } else if (status == "READY") {
          data.PageSize = this.readyBundlePageSize;
          data.PageNum = this.readyBundleOptions.page;
        } else if (status == "DELIVERED") {
          data.PageSize = this.deliveredBundlePageSize;
          data.PageNum = this.deliveredBundleOptions.page;
        }

        const response = await SearchBundle(data);
        console.table(response.data.Results);
        for (let bundle of response.data.Results) {
          if (bundle.DeliveryType == "SELF_PICKUP_SPOT") {
            bundle["Add"] = bundle.CenterAdd;
          } else {
            bundle["Add"] = bundle.MemberAdd;
          }
        }

        if (status == "PROCESSING") {
          this.processingBundles = response.data.Results;
          this.totalProcessingBundles = response.data.Total;
        } else if (status == "READY") {
          this.readyBundles = response.data.Results;
          this.totalReadyBundles = response.data.Total;
        } else if (status == "DELIVERED") {
          this.deliveredBundles = response.data.Results;
          this.totalDeliveredBundles = response.data.Total;
        }
        this.loadingBundles = false;
      } catch (error) {
        console.log(error);
      }
    },
    async flutterPaymentEvent(event) {
      try {
        console.log("flutterPaymentEvent");
        console.log(JSON.stringify(event.detail));
        let data = event.detail;
        if (data.status == "FAIL") {
          this.text = i18n.t("message.payment_failed");
          this.snackbarColor = "red";
          this.snackbarTimeout = -1;
          this.snackbar = true;
          return;
        }

        if (data.queryType == "ONCE") {
          let result = await this.inquiryPayment(data.paymentId);
          if (!result) {
            this.pollingPayment(data.type, data.paymentId);
          }
        } else if (data.queryType == "POLLING") {
          this.pollingPayment(data.type, data.paymentId);
        }
      } catch (error) {
        console.log(`flutterPaymentEvent: ${error}`);
      }
    },
    pollingPayment(method, paymentId) {
      if (method == "ALIPAY_HK") {
        this.pollingDialogConfig.interval = 5000;
      } else if (method == "HSBC_PAYME") {
        this.pollingDialogConfig.interval = 5000;
      }
      this.pollingDialogConfig.paymentId = paymentId;
      this.showPollingDialog = true;
      this.$nextTick(() => {
        console.log("nextTick");
        this.$refs.pollingDialog.pollQuery();
      });
    },
    //is iphone/android mobile
    isMobileWeb() {
      let userAgt = navigator.userAgent || navigator.vendor || window.opera;
      const re = /(iPhone)+.*(Mobile)+|(Android)+.*(Mobile)+/gi;
      let isMobileWeb = re.test(userAgt);
      console.log(userAgt, isMobileWeb);
      return isMobileWeb;
    },
  },
  computed: {
    isFlutter() {
      return localStorage.getItem("flutter") == "true";
    },
    totalGateInSelected() {
      const totals = this.gateInSelected.reduce(
        (acc, d) => {
          acc.ChgWgt += d.ChgWgt;
          acc.Wgt += d.Wgt;
          acc.Pkg += d.Pkg;
          return acc;
        },
        {
          ChgWgt: 0,
          Wgt: 0,
          Pkg: 0,
        }
      );
      totals.ChgWgt = totals.ChgWgt.toFixed(3);
      console.log(totals);
      return totals;
    },
    pendingHeaders() {
      return [
        {
          text: i18n.t("label.courier_no"),
          align: "start",
          value: "CourierNo",
        },
        { text: i18n.t("label.order_no"), value: "OrderNo" },
        { text: i18n.t("label.package"), value: "Pkg" },
        { text: i18n.t("label.warehouse"), value: "OriginWhName" },
        { text: i18n.t("label.product_name"), value: "ProductName" },
        { text: i18n.t("label.actions"), value: "actions", sortable: false },
      ];
    },
    gateInheaders() {
      return [
        // { text: i18n.t("label.warehouse"), value: "OriginWhName" },
        { text: i18n.t("label.order_no"), value: "OrderNo" },
        { text: i18n.t("label.courier_no"), value: "CourierNo" },
        { text: i18n.t("label.package"), value: "Pkg" },
        { text: i18n.t("label.weight"), value: "Wgt" },
        { text: i18n.t("label.chg_weight"), value: "ChgWgt" },
        { text: i18n.t("label.product_name"), value: "ProductName" },
        { text: i18n.t("label.actions"), value: "actions", sortable: false },
      ];
    },
    showSelectedOrdersHeaders() {
      return [
        { text: i18n.t("label.order_no"), value: "OrderNo" },
        { text: i18n.t("label.chg_weight"), value: "ChgWgt" },
      ];
    },
    processingHeaders() {
      return [
        { text: i18n.t("label.bundle_no"), value: "BundleNo" },
        { text: i18n.t("label.no_of_label"), value: "OrderViews.length" },
        { text: i18n.t("label.package"), value: "Pkg" },
        { text: i18n.t("label.weight"), value: "Wgt" },
        { text: i18n.t("label.issue_date"), value: "IssueDate" },
        { text: i18n.t("label.address"), value: "Add" },
        { text: i18n.t("label.cargo_status"), value: "LatestStatusRemark" },
        { text: i18n.t("label.actions"), value: "actions", sortable: false },
      ];
    },
    readyHeaders() {
      return [
        { text: i18n.t("label.bundle_no"), value: "BundleNo" },
        { text: i18n.t("label.no_of_label"), value: "OrderViews.length" },
        { text: i18n.t("label.package"), value: "Pkg" },
        { text: i18n.t("label.weight"), value: "Wgt" },
        { text: i18n.t("label.issue_date"), value: "IssueDate" },
        { text: i18n.t("label.address"), value: "Add" },
        { text: i18n.t("label.actions"), value: "actions", sortable: false },
      ];
    },
    deliveredHeaders() {
      return [
        { text: i18n.t("label.bundle_no"), value: "BundleNo" },
        { text: i18n.t("label.no_of_label"), value: "OrderViews.length" },
        { text: i18n.t("label.package"), value: "Pkg" },
        { text: i18n.t("label.weight"), value: "Wgt" },
        { text: i18n.t("label.issue_date"), value: "IssueDate" },
        { text: i18n.t("label.address"), value: "Add" },
        { text: i18n.t("label.actions"), value: "actions", sortable: false },
      ];
    },
    orderViewHeaders() {
      return [
        { text: i18n.t("label.order_no"), value: "OrderNo" },
        { text: i18n.t("label.product_name"), value: "ProductName" },
        { text: i18n.t("label.courier_no"), value: "CourierNo" },
        { text: i18n.t("label.package"), value: "Pkg" },
        { text: i18n.t("label.weight"), value: "Wgt" },
      ];
    },
  },
  created() {
    this.order = this.resetNewOrder();
  },
  mounted() {
    this.isMobileWeb();

    if (this.isFlutter) {
      // add message listener
      console.log("addEventListener flutterPaymentEvent");
      window.addEventListener(
        "flutterPaymentEvent",
        this.flutterPaymentEvent,
        false
      );
    }

    this.processingBundleOptions.page = 1;
    this.readyBundleOptions.page = 1;
    this.deliveredBundleOptions.page = 1;
    this.searchOrder("ORIGIN_IN");
    if (this.$route.query.PaymentID != undefined) {
      console.log("PaymentID", this.$route.query.PaymentID);
      let paymentId = this.$route.query.PaymentID;
      let status = this.$route.query.Status;
      let currentPaymentID = localStorage.getItem("PaymentID");
      let currentPaymentMethod = localStorage.getItem("PaymentMethod");
      console.log(status);
      if (status == "SUCCESS" && paymentId == currentPaymentID) {
        localStorage.removeItem("PaymentID");
        localStorage.removeItem("PaymentMethod");
        this.tab = 1;
        this.check = 3;
        this.checkoutDialog = true;
        this.paymentMethod = currentPaymentMethod;
        this.resetBundling();
      } else if (status == "FAIL") {
        this.text = i18n.t("message.payment_failed");
        this.snackbarColor = "red";
        this.snackbarTimeout = -1;
        this.snackbar = true;
      }

      this.$router.replace({ name: "management" });
    }
  },
  watch: {
    deliveryMethod(val) {
      console.log("deliveryMethod", val);
      if (val === "SELF_PICKUP_SPOT") {
        this.$refs.selectSpot.setDefault();
      } else if (val === "DIRECT_DELIVERY") {
        this.$refs.selectMember.setDefault();
      }
    },
    Spot() {
      if (this.Spot != null) {
        this.SpotAddress = this.Spot.Address;
      } else {
        this.SpotAddress = "";
      }
    },
    Member() {
      if (this.Member != null) {
        this.MemberAddress = this.Member.Address;
      } else {
        this.MemberAddress = "";
      }
    },
    GateInWarehouse() {
      this.GateInWarehouse?.CenterNo && this.searchGateInOrder();
    },
    processingBundleOptions: {
      handler() {
        this.searchBundle("PROCESSING");
      },
      deep: true,
    },
    readyBundleOptions: {
      handler() {
        this.searchBundle("READY");
      },
      deep: true,
    },
    deliveredBundleOptions: {
      handler() {
        this.searchBundle("DELIVERED");
      },
      deep: true,
    },
    showAlipayQrForm(val) {
      console.log("showAlipayQrForm:" + val);
      if (!val) {
        this.resetAlipayDialog();
      }
    },
    showPaymeQrForm(val) {
      console.log("showPaymeQrForm:" + val);
      if (!val) {
        this.resetPaymeDialog();
      }
    },
  },
};
</script>

<style scoped>
.loading-dialog {
  background-color: #303030;
}

/* @media only screen and (max-width: 959px) {
  .v-stepper:not(.v-stepper--vertical) >>> .v-stepper__label {
    display: flex !important;
  }
} */

.v-data-table >>> .v-data-table__mobile-row {
  min-height: 20px !important;
}

@media (max-width: 960px) {
  .v-dialog__content {
    justify-content: center;
    align-items: flex-start;
  }
}
.checkout-dialog >>> .v-stepper__header {
  height: 42px !important;
}

.checkout-dialog >>> .v-divider {
  border-color: rgba(140, 198, 63) !important;
}

.container-border {
  border-style: solid;
  border-width: 1px;
  border-radius: 16px;
  border-color: rgba(140, 198, 63) !important;
}

:lang(en) {
  --select-all-label: "Select All";
}
:lang(zh) {
  --select-all-label: "全選";
}
.gate-in-orders >>> .v-data-table-header .v-data-table__checkbox::after {
  content: var(--select-all-label);
  display: block;
}
.gate-in-orders >>> .v-data-table-header-mobile__wrapper {
  float: right;
}
.gate-in-orders >>> .v-data-table-header-mobile > tr > th {
  padding-right: 4px;
}
.gate-in-orders
  >>> .v-data-table-header-mobile__wrapper
  .v-input--selection-controls__ripple {
  margin: 0px;
  top: -5px;
  left: -5px;
}
</style>
